import { Button } from "../Button/Button";
import type { ModalWidth } from "../Modal/Modal";
import { ModalDrawer } from "../ModalDrawer/ModalDrawer";
import { Text } from "../Text/Text";

interface DealUnavailableDialogProps {
  open: boolean;
  onClose: () => void;
  modalWidth?: ModalWidth;
}

export function DealUnavailableDialog(
  props: DealUnavailableDialogProps,
): React.ReactNode {
  const { open, onClose, modalWidth } = props;

  return (
    <ModalDrawer
      open={open}
      title="That deal is unavailable"
      onClose={onClose}
      background="jets-beige"
      modalWidth={modalWidth}
      footer={
        <Button primary onClick={onClose}>
          Close
        </Button>
      }
    >
      <Text>
        Sorry, that deal is currently unavailable. Try adding a different deal
        or browsing the menu.
      </Text>
    </ModalDrawer>
  );
}
